import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import media from './media'
/**
* @see \App\Http\Controllers\Admin\ClassifiedListController::index
* @see app/Http/Controllers/Admin/ClassifiedListController.php:36
* @route '/admin/classifieds'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin/classifieds',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\ClassifiedListController::index
* @see app/Http/Controllers/Admin/ClassifiedListController.php:36
* @route '/admin/classifieds'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ClassifiedListController::index
* @see app/Http/Controllers/Admin/ClassifiedListController.php:36
* @route '/admin/classifieds'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ClassifiedListController::index
* @see app/Http/Controllers/Admin/ClassifiedListController.php:36
* @route '/admin/classifieds'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\ClassifiedListController::index
* @see app/Http/Controllers/Admin/ClassifiedListController.php:36
* @route '/admin/classifieds'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ClassifiedListController::index
* @see app/Http/Controllers/Admin/ClassifiedListController.php:36
* @route '/admin/classifieds'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ClassifiedListController::index
* @see app/Http/Controllers/Admin/ClassifiedListController.php:36
* @route '/admin/classifieds'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\ClassifiedListController::exportMethod
* @see app/Http/Controllers/Admin/ClassifiedListController.php:60
* @route '/admin/classifieds/export'
*/
export const exportMethod = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: exportMethod.url(options),
    method: 'get',
})

exportMethod.definition = {
    methods: ["get","head"],
    url: '/admin/classifieds/export',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\ClassifiedListController::exportMethod
* @see app/Http/Controllers/Admin/ClassifiedListController.php:60
* @route '/admin/classifieds/export'
*/
exportMethod.url = (options?: RouteQueryOptions) => {
    return exportMethod.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ClassifiedListController::exportMethod
* @see app/Http/Controllers/Admin/ClassifiedListController.php:60
* @route '/admin/classifieds/export'
*/
exportMethod.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: exportMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ClassifiedListController::exportMethod
* @see app/Http/Controllers/Admin/ClassifiedListController.php:60
* @route '/admin/classifieds/export'
*/
exportMethod.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: exportMethod.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\ClassifiedListController::exportMethod
* @see app/Http/Controllers/Admin/ClassifiedListController.php:60
* @route '/admin/classifieds/export'
*/
const exportMethodForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ClassifiedListController::exportMethod
* @see app/Http/Controllers/Admin/ClassifiedListController.php:60
* @route '/admin/classifieds/export'
*/
exportMethodForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ClassifiedListController::exportMethod
* @see app/Http/Controllers/Admin/ClassifiedListController.php:60
* @route '/admin/classifieds/export'
*/
exportMethodForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

exportMethod.form = exportMethodForm

/**
* @see \App\Http\Controllers\Admin\ClassifiedListController::bulk
* @see app/Http/Controllers/Admin/ClassifiedListController.php:94
* @route '/admin/classifieds/bulk'
*/
export const bulk = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulk.url(options),
    method: 'post',
})

bulk.definition = {
    methods: ["post"],
    url: '/admin/classifieds/bulk',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\ClassifiedListController::bulk
* @see app/Http/Controllers/Admin/ClassifiedListController.php:94
* @route '/admin/classifieds/bulk'
*/
bulk.url = (options?: RouteQueryOptions) => {
    return bulk.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ClassifiedListController::bulk
* @see app/Http/Controllers/Admin/ClassifiedListController.php:94
* @route '/admin/classifieds/bulk'
*/
bulk.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulk.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ClassifiedListController::bulk
* @see app/Http/Controllers/Admin/ClassifiedListController.php:94
* @route '/admin/classifieds/bulk'
*/
const bulkForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulk.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ClassifiedListController::bulk
* @see app/Http/Controllers/Admin/ClassifiedListController.php:94
* @route '/admin/classifieds/bulk'
*/
bulkForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulk.url(options),
    method: 'post',
})

bulk.form = bulkForm

/**
* @see \App\Http\Controllers\Admin\ClassifiedEditController::edit
* @see app/Http/Controllers/Admin/ClassifiedEditController.php:52
* @route '/admin/classifieds/{classified}/edit'
*/
export const edit = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/admin/classifieds/{classified}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\ClassifiedEditController::edit
* @see app/Http/Controllers/Admin/ClassifiedEditController.php:52
* @route '/admin/classifieds/{classified}/edit'
*/
edit.url = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { classified: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { classified: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            classified: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: typeof args.classified === 'object'
        ? args.classified.id
        : args.classified,
    }

    return edit.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ClassifiedEditController::edit
* @see app/Http/Controllers/Admin/ClassifiedEditController.php:52
* @route '/admin/classifieds/{classified}/edit'
*/
edit.get = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ClassifiedEditController::edit
* @see app/Http/Controllers/Admin/ClassifiedEditController.php:52
* @route '/admin/classifieds/{classified}/edit'
*/
edit.head = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\ClassifiedEditController::edit
* @see app/Http/Controllers/Admin/ClassifiedEditController.php:52
* @route '/admin/classifieds/{classified}/edit'
*/
const editForm = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ClassifiedEditController::edit
* @see app/Http/Controllers/Admin/ClassifiedEditController.php:52
* @route '/admin/classifieds/{classified}/edit'
*/
editForm.get = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ClassifiedEditController::edit
* @see app/Http/Controllers/Admin/ClassifiedEditController.php:52
* @route '/admin/classifieds/{classified}/edit'
*/
editForm.head = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Admin\ClassifiedEditController::update
* @see app/Http/Controllers/Admin/ClassifiedEditController.php:86
* @route '/admin/classifieds/{classified}'
*/
export const update = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/admin/classifieds/{classified}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\ClassifiedEditController::update
* @see app/Http/Controllers/Admin/ClassifiedEditController.php:86
* @route '/admin/classifieds/{classified}'
*/
update.url = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { classified: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { classified: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            classified: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: typeof args.classified === 'object'
        ? args.classified.id
        : args.classified,
    }

    return update.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ClassifiedEditController::update
* @see app/Http/Controllers/Admin/ClassifiedEditController.php:86
* @route '/admin/classifieds/{classified}'
*/
update.put = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\ClassifiedEditController::update
* @see app/Http/Controllers/Admin/ClassifiedEditController.php:86
* @route '/admin/classifieds/{classified}'
*/
const updateForm = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ClassifiedEditController::update
* @see app/Http/Controllers/Admin/ClassifiedEditController.php:86
* @route '/admin/classifieds/{classified}'
*/
updateForm.put = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\ClassifiedEditController::situation
* @see app/Http/Controllers/Admin/ClassifiedEditController.php:127
* @route '/admin/classifieds/{classified}/situation'
*/
export const situation = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: situation.url(args, options),
    method: 'patch',
})

situation.definition = {
    methods: ["patch"],
    url: '/admin/classifieds/{classified}/situation',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Admin\ClassifiedEditController::situation
* @see app/Http/Controllers/Admin/ClassifiedEditController.php:127
* @route '/admin/classifieds/{classified}/situation'
*/
situation.url = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { classified: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { classified: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            classified: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: typeof args.classified === 'object'
        ? args.classified.id
        : args.classified,
    }

    return situation.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ClassifiedEditController::situation
* @see app/Http/Controllers/Admin/ClassifiedEditController.php:127
* @route '/admin/classifieds/{classified}/situation'
*/
situation.patch = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: situation.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\ClassifiedEditController::situation
* @see app/Http/Controllers/Admin/ClassifiedEditController.php:127
* @route '/admin/classifieds/{classified}/situation'
*/
const situationForm = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: situation.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ClassifiedEditController::situation
* @see app/Http/Controllers/Admin/ClassifiedEditController.php:127
* @route '/admin/classifieds/{classified}/situation'
*/
situationForm.patch = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: situation.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

situation.form = situationForm

/**
* @see \App\Http\Controllers\Admin\ClassifiedEditController::galleryOrder
* @see app/Http/Controllers/Admin/ClassifiedEditController.php:179
* @route '/admin/classifieds/{classified}/gallery-order'
*/
export const galleryOrder = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: galleryOrder.url(args, options),
    method: 'put',
})

galleryOrder.definition = {
    methods: ["put"],
    url: '/admin/classifieds/{classified}/gallery-order',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\ClassifiedEditController::galleryOrder
* @see app/Http/Controllers/Admin/ClassifiedEditController.php:179
* @route '/admin/classifieds/{classified}/gallery-order'
*/
galleryOrder.url = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { classified: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { classified: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            classified: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: typeof args.classified === 'object'
        ? args.classified.id
        : args.classified,
    }

    return galleryOrder.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ClassifiedEditController::galleryOrder
* @see app/Http/Controllers/Admin/ClassifiedEditController.php:179
* @route '/admin/classifieds/{classified}/gallery-order'
*/
galleryOrder.put = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: galleryOrder.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\ClassifiedEditController::galleryOrder
* @see app/Http/Controllers/Admin/ClassifiedEditController.php:179
* @route '/admin/classifieds/{classified}/gallery-order'
*/
const galleryOrderForm = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: galleryOrder.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ClassifiedEditController::galleryOrder
* @see app/Http/Controllers/Admin/ClassifiedEditController.php:179
* @route '/admin/classifieds/{classified}/gallery-order'
*/
galleryOrderForm.put = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: galleryOrder.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

galleryOrder.form = galleryOrderForm

/**
* @see \App\Http\Controllers\ClassifiedController::destroy
* @see app/Http/Controllers/ClassifiedController.php:875
* @route '/admin/classifieds/{classified}'
*/
export const destroy = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/admin/classifieds/{classified}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\ClassifiedController::destroy
* @see app/Http/Controllers/ClassifiedController.php:875
* @route '/admin/classifieds/{classified}'
*/
destroy.url = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { classified: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { classified: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            classified: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: typeof args.classified === 'object'
        ? args.classified.id
        : args.classified,
    }

    return destroy.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ClassifiedController::destroy
* @see app/Http/Controllers/ClassifiedController.php:875
* @route '/admin/classifieds/{classified}'
*/
destroy.delete = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\ClassifiedController::destroy
* @see app/Http/Controllers/ClassifiedController.php:875
* @route '/admin/classifieds/{classified}'
*/
const destroyForm = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ClassifiedController::destroy
* @see app/Http/Controllers/ClassifiedController.php:875
* @route '/admin/classifieds/{classified}'
*/
destroyForm.delete = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\ClassifiedController::setMainImage
* @see app/Http/Controllers/ClassifiedController.php:1011
* @route '/admin/classifieds/{classified}/set-main-image/{mediaId}'
*/
export const setMainImage = (args: { classified: string | number | { id: string | number }, mediaId: string | number } | [classified: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: setMainImage.url(args, options),
    method: 'post',
})

setMainImage.definition = {
    methods: ["post"],
    url: '/admin/classifieds/{classified}/set-main-image/{mediaId}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ClassifiedController::setMainImage
* @see app/Http/Controllers/ClassifiedController.php:1011
* @route '/admin/classifieds/{classified}/set-main-image/{mediaId}'
*/
setMainImage.url = (args: { classified: string | number | { id: string | number }, mediaId: string | number } | [classified: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            classified: args[0],
            mediaId: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: typeof args.classified === 'object'
        ? args.classified.id
        : args.classified,
        mediaId: args.mediaId,
    }

    return setMainImage.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace('{mediaId}', parsedArgs.mediaId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ClassifiedController::setMainImage
* @see app/Http/Controllers/ClassifiedController.php:1011
* @route '/admin/classifieds/{classified}/set-main-image/{mediaId}'
*/
setMainImage.post = (args: { classified: string | number | { id: string | number }, mediaId: string | number } | [classified: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: setMainImage.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ClassifiedController::setMainImage
* @see app/Http/Controllers/ClassifiedController.php:1011
* @route '/admin/classifieds/{classified}/set-main-image/{mediaId}'
*/
const setMainImageForm = (args: { classified: string | number | { id: string | number }, mediaId: string | number } | [classified: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: setMainImage.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ClassifiedController::setMainImage
* @see app/Http/Controllers/ClassifiedController.php:1011
* @route '/admin/classifieds/{classified}/set-main-image/{mediaId}'
*/
setMainImageForm.post = (args: { classified: string | number | { id: string | number }, mediaId: string | number } | [classified: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: setMainImage.url(args, options),
    method: 'post',
})

setMainImage.form = setMainImageForm

/**
* @see \App\Http\Controllers\ClassifiedController::statusData
* @see app/Http/Controllers/ClassifiedController.php:1429
* @route '/admin/classifieds/{classified}/status-data'
*/
export const statusData = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: statusData.url(args, options),
    method: 'get',
})

statusData.definition = {
    methods: ["get","head"],
    url: '/admin/classifieds/{classified}/status-data',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ClassifiedController::statusData
* @see app/Http/Controllers/ClassifiedController.php:1429
* @route '/admin/classifieds/{classified}/status-data'
*/
statusData.url = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { classified: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { classified: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            classified: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: typeof args.classified === 'object'
        ? args.classified.id
        : args.classified,
    }

    return statusData.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ClassifiedController::statusData
* @see app/Http/Controllers/ClassifiedController.php:1429
* @route '/admin/classifieds/{classified}/status-data'
*/
statusData.get = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: statusData.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::statusData
* @see app/Http/Controllers/ClassifiedController.php:1429
* @route '/admin/classifieds/{classified}/status-data'
*/
statusData.head = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: statusData.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ClassifiedController::statusData
* @see app/Http/Controllers/ClassifiedController.php:1429
* @route '/admin/classifieds/{classified}/status-data'
*/
const statusDataForm = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: statusData.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::statusData
* @see app/Http/Controllers/ClassifiedController.php:1429
* @route '/admin/classifieds/{classified}/status-data'
*/
statusDataForm.get = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: statusData.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::statusData
* @see app/Http/Controllers/ClassifiedController.php:1429
* @route '/admin/classifieds/{classified}/status-data'
*/
statusDataForm.head = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: statusData.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

statusData.form = statusDataForm

/**
* @see \App\Http\Controllers\ClassifiedController::updateStatus
* @see app/Http/Controllers/ClassifiedController.php:1367
* @route '/admin/classifieds/{classified}/status'
*/
export const updateStatus = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: updateStatus.url(args, options),
    method: 'patch',
})

updateStatus.definition = {
    methods: ["patch"],
    url: '/admin/classifieds/{classified}/status',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\ClassifiedController::updateStatus
* @see app/Http/Controllers/ClassifiedController.php:1367
* @route '/admin/classifieds/{classified}/status'
*/
updateStatus.url = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { classified: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { classified: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            classified: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: typeof args.classified === 'object'
        ? args.classified.id
        : args.classified,
    }

    return updateStatus.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ClassifiedController::updateStatus
* @see app/Http/Controllers/ClassifiedController.php:1367
* @route '/admin/classifieds/{classified}/status'
*/
updateStatus.patch = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: updateStatus.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\ClassifiedController::updateStatus
* @see app/Http/Controllers/ClassifiedController.php:1367
* @route '/admin/classifieds/{classified}/status'
*/
const updateStatusForm = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updateStatus.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ClassifiedController::updateStatus
* @see app/Http/Controllers/ClassifiedController.php:1367
* @route '/admin/classifieds/{classified}/status'
*/
updateStatusForm.patch = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updateStatus.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

updateStatus.form = updateStatusForm

/**
* @see \App\Http\Controllers\ClassifiedController::statistics
* @see app/Http/Controllers/ClassifiedController.php:1309
* @route '/admin/classifieds/{classified}/statistics'
*/
export const statistics = (args: { classified: string | number } | [classified: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: statistics.url(args, options),
    method: 'get',
})

statistics.definition = {
    methods: ["get","head"],
    url: '/admin/classifieds/{classified}/statistics',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ClassifiedController::statistics
* @see app/Http/Controllers/ClassifiedController.php:1309
* @route '/admin/classifieds/{classified}/statistics'
*/
statistics.url = (args: { classified: string | number } | [classified: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { classified: args }
    }

    if (Array.isArray(args)) {
        args = {
            classified: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: args.classified,
    }

    return statistics.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ClassifiedController::statistics
* @see app/Http/Controllers/ClassifiedController.php:1309
* @route '/admin/classifieds/{classified}/statistics'
*/
statistics.get = (args: { classified: string | number } | [classified: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: statistics.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::statistics
* @see app/Http/Controllers/ClassifiedController.php:1309
* @route '/admin/classifieds/{classified}/statistics'
*/
statistics.head = (args: { classified: string | number } | [classified: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: statistics.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ClassifiedController::statistics
* @see app/Http/Controllers/ClassifiedController.php:1309
* @route '/admin/classifieds/{classified}/statistics'
*/
const statisticsForm = (args: { classified: string | number } | [classified: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: statistics.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::statistics
* @see app/Http/Controllers/ClassifiedController.php:1309
* @route '/admin/classifieds/{classified}/statistics'
*/
statisticsForm.get = (args: { classified: string | number } | [classified: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: statistics.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClassifiedController::statistics
* @see app/Http/Controllers/ClassifiedController.php:1309
* @route '/admin/classifieds/{classified}/statistics'
*/
statisticsForm.head = (args: { classified: string | number } | [classified: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: statistics.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

statistics.form = statisticsForm

const classifieds = {
    index: Object.assign(index, index),
    export: Object.assign(exportMethod, exportMethod),
    bulk: Object.assign(bulk, bulk),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    situation: Object.assign(situation, situation),
    galleryOrder: Object.assign(galleryOrder, galleryOrder),
    destroy: Object.assign(destroy, destroy),
    media: Object.assign(media, media),
    setMainImage: Object.assign(setMainImage, setMainImage),
    statusData: Object.assign(statusData, statusData),
    updateStatus: Object.assign(updateStatus, updateStatus),
    statistics: Object.assign(statistics, statistics),
}

export default classifieds